<template>
  <div class="scores-container">
  <div class="risk-score-card">

       <!-- Monthly Budget Summary -->
 
    
      <i class="fa fa-calendar risk-icon"> Financial Calendar</i>  <button class='button' @click="currentTab = 'addEvent'"><i class="fas fa-plus"></i> Add</button></div>


    <div class="toolbar">
      <button @click="openCatExplanation('financialcalendar')"><i class="fa fa-paw risk-icon"></i></button>
      <button @click="currentTab = 'list'"><i class="fas fa-list"></i> Personal Events</button>
      <button @click="currentTab = 'automated'"><i class="fas fa-list"></i> Market Events</button>
    
    
     <!-- List View -->
     <div v-if="currentTab === 'list'">
      <table>
        <tr>
          <th @click="sortEventsByDate">Date</th>
          <th @click="sortEventsByCategory">Category</th>
          <th> Event Name</th>
          <th>Amount</th>
          <th @click="sortEventsByPriority">Priority</th>
          <th>Update</th>
     
        </tr>
        <tr v-for="event in events" :key="event.id">
          <td>{{ formatDate(event.event_date) }}</td>
          <td>{{ event.event_category }}</td>
          <td>{{ event.event_name }}</td>
    
          <td>${{ formatAmount(event.amount_due) }} {{ event.currency }}</td>
          <td>{{ getPriorityText(event.priority) }}</td>
          <td><button @click="openEditForm(event)">Edit</button></td>
  <!-- Removed recurrence pattern until able to get it working properly -->
        </tr>
      </table>
    </div>

    <div v-if="currentTab === 'automated'">
  <table>
    <tr>
      <th>Date</th>
      <th>Source</th>
      <th>Market Event</th>
  
    </tr>
    <tr v-for="event in marketEvents" :key="event.id">
      <td>{{ formatDate(event.event_date) }}</td>
      <td>{{ event.event_type }}</td>
      <td>{{ event.title }}</td>

    </tr>
  </table>
</div>


    <!-- Add Event Form -->
    <div v-if="currentTab === 'addEvent'">
      <form @submit.prevent="isEditing ? updateEvent() : addEvent()" class="event-form">
        <label>Date: <input type="date" v-model="newEvent.event_date" required /></label>
        <label>Event Category:
          <select v-model="newEvent.event_category" required>
            <option value="Income">Income</option>
            <option value="Expense">Expense</option>
            <option value="Reminder">Informational Reminder</option>
          </select>
        </label>
        <label>Event Name: <input type="text" v-model="newEvent.event_name" required /></label>

        <label>Priority:
    <select v-model="newEvent.priority">
      <option value="1">Low</option>
      <option value="2">Medium</option>
      <option value="3">High</option>
    </select>
  </label>

        <label>Amount: <input type="number" step="0.01" v-model="newEvent.amount_due" /></label>
        <label>Currency:
          <select v-model="newEvent.currency" required>
            <option value="CAD">CAD</option>
            <option value="USD">USD</option>
          </select>
        </label>
        <label>Event Status:
          <select v-model="newEvent.event_status" required>
            <option value="Pending">Pending</option>
            <option value="Reviewing">Reviewing</option>
            <option value="completed">Completed</option>
          </select>
        </label>
        <div>

</div>
        <button type="submit">{{ isEditing ? 'Update' : 'Add' }} Event</button>
      </form>
    </div>

    <FullCalendar :options="calendarOptions">
  <template v-slot:eventContent="arg">
    <div>
      <b>{{ arg.event.title }}</b><br>
      <b>{{ arg.event.priority }}</b><br>
  
    </div>
  </template>
</FullCalendar>
</div><br>


</div>




</template>


<script>
import axios from 'axios';
import { Auth } from 'aws-amplify';
import FullCalendar from '@fullcalendar/vue3';
import dayGridPlugin from '@fullcalendar/daygrid';
import Swal from 'sweetalert2';

export default {
  components: {
    FullCalendar
  },
  data() {
    return {
      currentTab: 'list',
      eventColor: 'green',
      events: [],
      newEvent: {
        id: null,
        event_name: '',
        event_date: '',
        amount_due: 0,
        currency: 'CAD',
        event_status: 'Pending',
        priority: 1,
        color: 'black',
        sortOrder: 'asc',
        categorySortOrder: 'asc',
        statusSortOrder: 'asc',
        prioritySortOrder: 'asc',
        filteredEvents: [],
        
      },
      isEditing: false,
      calendarOptions: {
        plugins: [dayGridPlugin],
  initialView: 'dayGridMonth',
  weekends: true,
  events: [], // Your events array
  eventColor: '#36454f',
      },
      marketEvents: [],
      title: '',
      description: '',
      event_date: '',
      event_type: '',
      notes: '',
      catExplanations: [
      {
        section: 'financialcalendar',
        title: 'Cat Speak - Financial Calendar',
        text: 'Think of a Financial Calendar as your routine, much like a cat\'s schedule for meals, naps, and playtime. It keeps track of your upcoming income and expenses, adding reminders so you\'re always prepared - just think of those promotions that end and you get stuck with a much higher bill. With this calendar, you avoid surprises, just like a cat who knows exactly when it\'s time to eat or pounce. ',
    
      },
    ],
    };
  },

  
  methods: {
    async fetchEvents() {
      const user = await Auth.currentAuthenticatedUser();
      const response = await axios.get('https://api.riskypaws.com/frontoffice/api/financial-events/', {
        headers: { 'X-Cognito-Sub': user.attributes.sub }
      });
      this.events = response.data;
      this.filteredEvents = this.events.filter(event => event.event_status !== 'Completed');
    },
    formatAmount(amount) {
    return parseFloat(amount).toFixed(2);
  },
  
  openEditForm(event) {
    this.newEvent = { ...event };
    this.isEditing = true;
    this.currentTab = 'addEvent'; // switch to the form tab
  },
    selectEventForUpdate(event, index) {
      this.newEvent = { ...event };
      this.selectedEventIndex = index;
      this.currentTab = 'addEvent';
      this.isEditing = true;
    },
    
    sortEventsByDate() {
    if (this.sortOrder === 'asc') {
      this.events.sort((a, b) => new Date(a.event_date) - new Date(b.event_date));
      this.sortOrder = 'desc';
    } else {
      this.events.sort((a, b) => new Date(b.event_date) - new Date(a.event_date));
      this.sortOrder = 'asc';
    }
  },
  
  sortEventsByPriority() {
    this.events.sort((a, b) => {
      if (this.prioritySortOrder === 'asc') {
        return a.priority - b.priority;
      } else {
        return b.priority - a.priority;
      }
    });
    this.prioritySortOrder = this.prioritySortOrder === 'asc' ? 'desc' : 'asc';
  },

  sortEventsByCategory() {
    this.events.sort((a, b) => {
      if (this.categorySortOrder === 'asc') {
        return a.event_category.localeCompare(b.event_category);
      } else {
        return b.event_category.localeCompare(a.event_category);
      }
    });
    this.categorySortOrder = this.categorySortOrder === 'asc' ? 'desc' : 'asc';
  },
  sortEventsByStatus() {
    this.events.sort((a, b) => {
      if (this.statusSortOrder === 'asc') {
        return a.event_status.localeCompare(b.event_status);
      } else {
        return b.event_status.localeCompare(a.event_status);
      }
    });
    this.statusSortOrder = this.statusSortOrder === 'asc' ? 'desc' : 'asc';
  },
  openCatExplanation(sectionKey) {
  const explanation = this.catExplanations.find(ex => ex.section === sectionKey);
  if (explanation) {
    Swal.fire({
      title: explanation.title,
      text: explanation.text,
      confirmButtonText: 'Close'
    });
  }
},
    getPriorityText(priority) {
    switch (priority) {
      case 1:
        return 'Low';
      case 2:
        return 'Medium';
      case 3:
        return 'High';
      default:
        return '';
    }
  },

  

    editEvent(event) {
    this.newEvent = { ...event };
    this.isEditing = true;
    this.currentTab = 'addEvent';
  },
  async fetchMarketEvents() {
      try {
        const response = await axios.get('https://api.riskypaws.com/backoffice/api/financialcalendarevent/');
        this.marketEvents = response.data; // Store the fetched data in marketEvents array
      } catch (error) {
        console.error('Error fetching market events:', error);
      }
    },
    
    async updateEvent() {
      const user = await Auth.currentAuthenticatedUser();
      await axios.put(`https://api.riskypaws.com/frontoffice/api/financial-events/${this.newEvent.id}/`, this.newEvent, {
        headers: { 'X-Cognito-Sub': user.attributes.sub }
      });
      this.resetForm();
      await this.fetchEvents();
    },
    resetForm() {
      this.newEvent = {
        id: null,
        event_name: '',
        event_date: '',
        description: '',
        amount_due: 0,
        currency: 'CAD',
        event_category: '',
        event_status: 'Pending',
        priority: 1
      };
      this.isEditing = false;
    this.currentTab = 'list';
    },
    async addEvent() {
  const user = await Auth.currentAuthenticatedUser();

  // Format the date fields before sending
  if (this.newEvent.event_date) {
    this.newEvent.event_date = this.formatDate(this.newEvent.event_date);
  }
  if (this.newEvent.end_date) {
    this.newEvent.end_date = this.formatDate(this.newEvent.end_date);
  }

  await axios.post('https://api.riskypaws.com/frontoffice/api/financial-events/', this.newEvent, {
    headers: { 'X-Cognito-Sub': user.attributes.sub }
  });

  this.resetForm();
  await this.fetchEvents();
},

    formatDate(date) {
      return date ? new Date(date).toISOString().substring(0, 10) : '';
    }
  },

  computed: {
    calendarEvents() {
      return this.events.map(event => ({
      dates: event.event_date,
      title: event.event_name,
      description: event.description,
      amount_due: event.amount_due,
      currency: event.currency,
      event_category: event.event_category,
      
  
    
    }));
    }
  },



  mounted() {
    this.fetchEvents();
    this.fetchMarketEvents();
  },
  watch: {
    
    events(newEvents) {
      this.calendarOptions.events = newEvents.map(event => ({
        title: event.event_name, 
        start: event.event_date,
        description: event.description,
      amount_due: event.amount_due,
      }));
      
    }
  }
};
</script>






<style scoped>

.risk-score-card {
  display: flex;
  align-items: center;
  justify-content: space-between; /* Aligns items to start and end */

  max-width: 100%;
  padding: 20px;
  margin-bottom: 20px;
  background-image: linear-gradient(135deg, #36454f 0%, #5a6978 50%, #b0bec5 100%);
  color: white;
  font-size: 24px;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }

.calendar-container {
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 20px;
  margin: 20px;
  overflow: hidden; 
  color: black;
}


.toolbar button, .view-options button, .event-form button {
  background-image: linear-gradient(135deg, #6D5BBA 0%, #8D58BF 100%); /* Apply the same gradient as your app theme */
  color: white;
  border: none;
  padding: 10px 15px;
  border-radius: 5px;
  margin: 5px;
  cursor: pointer;
  transition: background-color 0.3s, box-shadow 0.3s;
}
.fc-daygrid-event, .fc-day-today, .fc-col-header-cell, .fc-scrollgrid {
  background-color: #808080 !important; /* Grey background; use #000000 for black */
  color: #ffffff !important; /* White text color for contrast */
}

.fc-daygrid-event:hover {
  background-color: #696969 !important; /* Darker grey on hover; adjust for black theme as needed */
}
.toolbar button:hover, .view-options button:hover, .event-form button:hover {
  background-image: linear-gradient(135deg, #8D58BF 0%, #6D5BBA 100%); /* Slightly adjust gradient for hover effect */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2); /* Add a shadow for depth */
}

table {
  width: 100%;
  border-collapse: collapse;
  border-radius: 5px;
  overflow: hidden;
}
.fc-event {
  background-color: black !important; /* Black background for events */
  color: white !important; /* White text */
  border: 1px solid white !important; /* White border */
}
.full-calendar .fc-event {
  background-color: black !important;
  color: white !important;
  border: 1px solid white !important;
}

.full-calendar .fc-event:hover {
  background-color: grey !important;
}
.fc-event:hover {
  background-color: grey !important; /* Grey background on hover */
}
th, td {
  text-align: left;
  padding: 8px;
  border-bottom: 1px solid #ddd;
}

th {
  background-color: #36454f;
  color: white;
}

tr:nth-child(even) {
  background-color: #f2f2f2;
}

input[type="text"], input[type="date"], input[type="number"], select {
  width: 100%;
  padding: 10px;
  margin: 8px 0;
  display: inline-block;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
}

label {
  display: block;
  margin-top: 10px;
}
.event-form {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  background-color: white;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.event-form label {
  display: block;
  margin-bottom: 5px;
  color: #333;
  font-weight: bold;
}

.event-form input[type="text"],
.event-form input[type="date"],
.event-form input[type="number"],
.event-form select {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-sizing: border-box;
}

.event-form input[type="text"]:hover,
.event-form input[type="date"]:hover,
.event-form input[type="number"]:hover,
.event-form select:hover {
  border-color: #4A148C; /* Dark purple */
}

.event-form button {
  grid-column: span 2;
  background-color: #4A148C; /* Dark purple */
  color: white;
  padding: 10px 15px;
  border-radius: 5px;
  border: none;
  cursor: pointer;
  transition: background-color 0.3s;
}

.event-form button:hover {
  background-color: #6C1B9A; /* Lighter purple */
}



.content-container {
background-color: #4A148C ;  /* Light orange color */
color: black;
padding: 5px;
border-radius: 20px;  /* Adjust this value to your preference */
overflow: hidden; 


}
.monthly-summary {
  display: flex;
  justify-content: space-around;
  padding: 20px;
  background-color: #f0f2f5;
  border-radius: 10px;
  margin: 20px 0;
}
.stingy-card {
padding: 20px;
border-radius: 10px;
box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
background-color: white;
}
.button {
  background-color: #4A148C; /* Dark purple */
  color: white;
  border: none;
  padding: 10px 15px;
  border-radius: 5px;
  margin: 5px;
  cursor: pointer;
  transition: background-color 0.3s;
}

@media screen and (max-width: 600px) {
  .risk-score-card, .toolbar button, .event-form label, .event-form input, .event-form select, .event-form button {
    font-size: 14px; /* Adjust font size for better readability on mobile */
  }

  .button, .toolbar button {
    padding: 8px 10px; /* Adjust button padding for easier clickability */
    margin: 4px; /* Reduce margin to fit more content */
  }

  .event-form {
    grid-template-columns: 1fr; /* Adjust form layout to single column for narrow screens */
  }

  input[type="date"], input[type="text"], input[type="number"], select {
    margin: 4px 0; /* Reduce margin around inputs for compact layout */
  }

  .event-form button {
    padding: 8px 10px; /* Adjust button size for mobile */
  }

  table, th, td {
    font-size: 12px; /* Smaller table font size for mobile */
  }
}
</style>

